<template>
    <div>
        <div class="panel panel-info"  >

            <!-- Default panel contents -->
            <div class="panel-heading">
                <i class="fa fa-bars" aria-hidden="true"></i> MENU EMPRESA
            </div>
            <div class="panel-body" v-if="user.level === 0" >
                <p>
                    <a :href="'#/empresa/0'" class="btn btn-info btn-block">NOVA EMPRESA</a>
                </p>
            </div>

        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            user: null
        };
    },
    beforeMount() {
        this.user = this.$store.state.user;
    }
};
</script>
